export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const authAppleConfig = {
  clientId: process.env.REACT_APP_APPLE_PUBLIC_CLIENT_ID || '',
  redirectURI: process.env.REACT_APP_APPLE_PUBLIC_REDIRECT_URL || '',
}